import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
	Box,
	Button,
	Checkbox,
	FormControl,
	FormLabel,
	Heading,
	HStack,
	Input,
	Link,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
	Textarea,
	Table,
	Thead,
	Tbody,
	Tfoot,
	Tr,
	Th,
	Td,
	TableCaption,
	Tooltip,
} from '@chakra-ui/react';
import { EmailIcon, InfoIcon } from '@chakra-ui/icons';
import { services } from './data';
import { secondary, columns } from '../app-data/admin';
import { displayChannel, displayStatus } from '../display/users-index';
import { indent } from '../utils';
import { options } from './data';
import { TableSorter } from './elements/TableSorter';
import { UserPopup } from './UserPopup';
const perPage = 50;

export const UsersIndex = ({ setUserID, admin }) => {
	const [wake, setWake] = useState(new Date());
	const [loading, setLoading] = useState(true);
	const [users, setUsers] = useState([]);
	const [usersCount, setUsersCount] = useState(0);
	const [email, setEmail] = useState('');
	const [invite, setInvite] = useState('');
	const [up, setUp] = useState(true);
	const [column, setColumn] = useState('status');
	const [selected, setSelected] = useState({});
	const [pattern, setPattern] = useState('');
	const [subject, setSubject] = useState('');
	const [message, setMessage] = useState('');
	const [isOpen, setIsOpen] = useState(false);
	const [isUserOpen, setIsUserOpen] = useState(false);
	const [id, setId] = useState(0);
	const [page, setPage] = useState(0);

	const onOpen = () => setIsOpen(true);
	const onClose = () => setIsOpen(false);
	const isEmailingDisabled = Object.keys(selected).length < 1;

	const onUserOpen = id => {
		setId(id);
		setIsUserOpen(true);
	};
	const onUserClose = () => setIsUserOpen(false);

	const handleInvite = () => {
		axios({
			method: 'post',
			url: `/users`,
			data: { email },
			...options(),
		})
			.then(res => {
				setInvite(res.data.invite);
				setEmail('');
				setWake(new Date());
			})
			.catch(console.log);
	};

	const handleSend = () => {
		axios({
			method: 'post',
			url: `/emails`,
			data: { subject, message, selected },
			...options(),
		})
			.then(res => {
				setSubject('');
				setMessage('');
			})
			.catch(console.log);
	};

	const sort = name => {
		setColumn(name);
		setUp(!up);
		setPage(0);
		setWake(new Date());
	};

	const offset = page * perPage;
	useEffect(() => {
		let active = true;
		async function load() {
			const res = await axios.get(
				`/users/NaN/${column}/${
					up ? 'a' : 'd'
				}/${offset}/${perPage}/${pattern}`,
				options()
			);
			if (!active) {
				return;
			}
			setUsers(res.data.users);
			setUsersCount(res.data.count);
			setLoading(false);
		}
		load();

		return () => {
			active = false;
		};
	}, [wake, offset, column, pattern, up]);

	if (loading) return <p>Loading...</p>;
	const pagesCount = Math.ceil(usersCount / perPage);
	const pages = [...Array(pagesCount).keys()];

	const usersObject = users.reduce(
		(acc, user) => ({
			...acc,
			[user.id]: user.email,
		}),
		{}
	);

	const checkSelected = (name, checked) => {
		if (checked) return { ...selected, [name]: usersObject[name] };
		const updated = { ...selected };
		delete updated[name];

		return updated;
	};

	const handleSelect = ({ target: { name, checked } }) =>
		setSelected(checkSelected(name, checked));

	const base64ToArrayBuffer = _base64Str => {
		const binaryString = window.atob(_base64Str);
		const binaryLen = binaryString.length;
		const bytes = new Uint8Array(binaryLen);
		for (let i = 0; i < binaryLen; i++) {
			const ascii = binaryString.charCodeAt(i);
			bytes[i] = ascii;
		}
		return bytes;
	};

	const showDocument = (_base64Str, _contentType) => {
		const byte = base64ToArrayBuffer(_base64Str);
		const blob = new Blob([byte], { type: _contentType });
		window.open(URL.createObjectURL(blob), '_blank');
	};

	const showAgreement = id =>
		axios.get(`/agreement/${id}`, options()).then(res => {
			if (!Array.isArray(res.data.agreement)) return;
			if (!res.data.agreement.length) return;
			const [{ src, ext }] = res.data.agreement;
			showDocument(src, ext);
		});

	const loadPage = e => {
		const id = e.target.dataset.id;
		setPage(Number(id));
	};

	return (
		<Box p={4}>
			<Heading fontSize={'3xl'} mb="6">
				Customers registry
			</Heading>
			<HStack pb={6}>
				<FormControl w="25%">
					<FormLabel>Email</FormLabel>
					<Input
						type="email"
						placeholder="Enter new user e-mail here"
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
				</FormControl>
				<FormControl w="25%">
					<FormLabel>&nbsp;</FormLabel>
					<Button d="block" w="100%" colorScheme="blue" onClick={handleInvite}>
						Invite
					</Button>
				</FormControl>
				{invite && (
					<FormControl w="50%">
						<FormLabel>Invite link</FormLabel>
						<Input type="text" value={invite} />
					</FormControl>
				)}
			</HStack>
			<HStack pb={6}>
				<FormControl w="50%">
					<FormLabel>Search</FormLabel>
					<Input
						type="text"
						placeholder="Enter customer e-mail or last name fragment here"
						value={pattern}
						onChange={e => setPattern(e.target.value)}
					/>
				</FormControl>
				<FormControl w="50%">
					<FormLabel>&nbsp;</FormLabel>
					<Button
						d="block"
						w="100%"
						colorScheme="green"
						isDisabled={isEmailingDisabled}
						onClick={onOpen}
					>
						Open Emailing
					</Button>
				</FormControl>
			</HStack>
			<HStack>
				{pages.map(pageIndex => (
					<Button
						key={pageIndex}
						colorScheme={pageIndex === page ? 'blue' : 'gray'}
						onClick={loadPage}
						data-id={pageIndex}
						size="xs"
					>
						{pageIndex + 1}
					</Button>
				))}
			</HStack>
			<Table variant="simple">
				<TableCaption>
					Список клиентов c отметками о добавленных документах, этапе и
					примечаниях
				</TableCaption>
				<Thead>
					<Tr>
						<TableSorter {...{ ...columns.lastName, up, sort }} />
						<TableSorter {...{ ...columns.firstName, up, sort }} />
						<TableSorter {...{ ...columns.service, up, sort }} />
						<TableSorter {...{ ...columns.uploaded, up, sort }} />
						<TableSorter {...{ ...columns.num, up, sort }} />
						<TableSorter {...{ ...columns.status, up, sort }} />
						<TableSorter {...{ ...columns.stage, up, sort }} />
						<Th>
							<InfoIcon />
						</Th>
						<TableSorter {...{ ...columns.term, up, sort }} />
						<Th>
							<TableSorter {...{ ...columns.sort, up, sort }} />
						</Th>
					</Tr>
				</Thead>
				<Tbody>
					{users.map(
						({
							id,
							email,
							firstName,
							lastName,
							uploaded,
							service,
							status,
							secondary_status,
							storage_link,
							channel,
							channel_details,
							term,
						}) => {
							service = service || 'cons';
							status = status || 'suspended';
							secondary_status = secondary_status || '';
							storage_link = storage_link || '';
							channel = channel || '';
							channel_details = channel_details || '';
							term = term || '';
							const num = indent(4, '0', id);

							return (
								<Tr key={id}>
									<Td cursor="pointer" onClick={() => setUserID(id)}>
										{lastName}
									</Td>
									<Td cursor="pointer" onClick={() => setUserID(id)}>
										{firstName}
									</Td>
									<Td cursor="pointer" onClick={() => onUserOpen(id)}>
										{services[service] || ''}
									</Td>
									{uploaded > 0 ? (
										<Td cursor="pointer" onClick={() => showAgreement(id)}>
											View
										</Td>
									) : (
										<Td>-</Td>
									)}
									<Td color="grey.200">
										{storage_link ? (
											<Link
												href={storage_link}
												target="_blank"
												py="1"
												px="2"
												bgColor="blue.500"
												color="white"
												borderRadius="md"
												_hover={{
													textDecoration: 'none',
												}}
											>
												{num}
											</Link>
										) : (
											num
										)}
									</Td>
									<Td>
										<Checkbox name={id} onChange={handleSelect}>
											{displayStatus(status)}
										</Checkbox>
									</Td>
									<Td>{secondary[secondary_status]}</Td>
									<Td>{displayChannel(channel, channel_details)}</Td>
									<Td>{term}</Td>
									<Td>
										<Tooltip label={email} placement="top-start">
											<Link href={`mailto:${email}`}>
												<EmailIcon color="teal" />
											</Link>
										</Tooltip>
									</Td>
								</Tr>
							);
						}
					)}
				</Tbody>
				<Tfoot>
					<Tr>
						<Th>Фамилия</Th>
						<Th>Имя</Th>
						<Th>Услуга</Th>
						<Th>#</Th>
						<Th>№</Th>
						<Th>*</Th>
						<Th>Этап</Th>
						<Th>
							<InfoIcon />
						</Th>
						<Th>Период работы</Th>
						<Th>
							<EmailIcon />
						</Th>
					</Tr>
				</Tfoot>
			</Table>
			<HStack>
				{pages.map(pageIndex => (
					<Button
						key={pageIndex}
						colorScheme={pageIndex === page ? 'blue' : 'gray'}
						onClick={loadPage}
						data-id={pageIndex}
						size="xs"
					>
						{pageIndex + 1}
					</Button>
				))}
			</HStack>
			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Send Emails</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Box>To: {Object.values(selected).join(', ')}</Box>
						<HStack pb={6}>
							<FormControl w="80%">
								<FormLabel>Subject</FormLabel>
								<Input
									type="text"
									placeholder="Enter e-mail subject here"
									value={subject}
									onChange={e => setSubject(e.target.value)}
								/>
							</FormControl>
							<FormControl w="20%">
								<FormLabel>&nbsp;</FormLabel>
								<Button
									d="block"
									w="100%"
									colorScheme="green"
									onClick={handleSend}
								>
									Send
								</Button>
							</FormControl>
						</HStack>
						<HStack pb={6}>
							<FormControl w="100%">
								<FormLabel>Message</FormLabel>
								<Textarea
									rows={7}
									placeholder="Enter e-mail text here"
									value={message}
									onChange={e => setMessage(e.target.value)}
									size="sm"
								/>
							</FormControl>
						</HStack>
					</ModalBody>
				</ModalContent>
			</Modal>
			<Modal isOpen={isUserOpen} onClose={onUserClose} size="full">
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Client management</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<UserPopup {...{ id, admin, onUserClose }} />
					</ModalBody>
				</ModalContent>
			</Modal>
		</Box>
	);
};
